module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/HC3NcV/tc-custom/9781426886430.jpg?1737166184530",
      "alt": "This image is the cover for the book Sheikh's Wife, Surrender to the Sheikh"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Sheikh's Wife, Surrender to the Sheikh\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("An American is reunited with her Sheikh husband in this rapturous romance from the ")]), _c('i', [_c('b', [_vm._v("New York Times–")])]), _c('b', [_vm._v("bestselling author.")])]), _c('p', [_vm._v("Sheikh Kahlil al-Assad hasn't forgiven Bryn for abandoning her wedding vows. Then he discovers that he's also missed out on the first years of his son's life. Kahlil decides to take revenge.")]), _c('p', [_vm._v("Bryn didn't realize—they are still husband and wife! She knows she can't deny Ben the daddy he's been asking for. So she agrees to return to Kahlil's desert kingdom. There she finds herself consigned to the harem quarters, where she must prepare for being taken back . . . into the Sheikh's bed!")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Jane Porter\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Jane Porter loves central California's golden foothills and miles of farmland, rich with the sweet and heady fragrance of orange blossoms. Her parents fed her imagination by taking Jane to Europe for a year where she became passionate about Italy and those gorgeous Italian men! Jane never minds a rainy day – that's when she sits at her desk and writes stories about far-away places, fascinating people, and most important of all, love. Visit her website at: www.janeporter.com")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0